module.exports = __webpack_public_path__ + "static/media/icon_login_off.c36ad081.svg";